'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { Add01Icon } from '@terra/ui-icons';
import { Button } from '../../components/button';

export type ListPageFilterPanelProps = {
  children?: ReactNode;
  onClear: () => void;
  isClearDisabled: boolean;
  addFilter?: {
    isActive: boolean;
    onClick: () => void;
  };
  selection?: ReactNode;
  trailing?: ReactNode;
  expandedContent?: ReactNode;
};

export function ListPageFilterPanel({
  children,
  onClear,
  isClearDisabled,
  addFilter,
  selection,
  trailing,
  expandedContent,
}: ListPageFilterPanelProps) {
  const t = useTranslations('designSystem.listPage');

  return (
    <VStack
      gap="3"
      alignItems="stretch"
      p="3"
      borderRadius="l3"
      bg="bg.neutral.subtleSoft"
    >
      <HStack gap="2" alignItems="center" w="full">
        <HStack gap="2" alignItems="center" flex="1" minW="0" flexWrap="wrap">
          {children}
          {addFilter ? (
            <Button
              size="xs"
              variant="ghost"
              h="6"
              gap="1"
              pl="1"
              pr="1.5"
              aria-expanded={addFilter.isActive}
              onClick={addFilter.onClick}
            >
              <Add01Icon size={14} />
              {t('addFilter')}
            </Button>
          ) : null}
        </HStack>
        {selection ? <Box flexShrink={0}>{selection}</Box> : null}
        {trailing ? <Box flexShrink={0}>{trailing}</Box> : null}
        <Button
          size="xs"
          variant="ghost"
          h="6"
          px="1.5"
          flexShrink={0}
          disabled={isClearDisabled}
          onClick={onClear}
        >
          {t('clear')}
        </Button>
      </HStack>
      {expandedContent}
    </VStack>
  );
}
